import React from 'react';
import ColorMap from './ColorMap';
import Slider from './Slider';
import {
  toHexString,
  parseToHsv,
  toRgbString,
} from './utils';
import { Wrapper } from './styledComponents';

class ColorPicker extends React.Component {
  defaultProps = {
    color: '#FFFFFF',
    opacitySlider: false
  };

  state = this.getStateFrom(this.props);

  componentWillReceiveProps(nextProps) {
    const nextState = this.getStateFrom(nextProps);

    if (this.state.color === nextState.color) {
      this.setState(nextState);
    }
  }

  getStateFrom(props) {
    const color = props.color && props.color !== null ? props.color : this.defaultProps.color;
    return {
      color: parseToHsv(color)
    };
  }

  getBackgroundGradient = () => {
    const [h, s, v] = this.state.color;
    const opaque = toRgbString([h, s, v, 1]);

    return `linear-gradient(to right, rgba(0,0,0,0) 0%, ${opaque} 100%)`;
  }

  getBackgroundHue = () => toRgbString([this.state.color[0], 100, 100]);

  handleAlphaChange = (alpha) => {
    const [h, s, v] = this.state.color;
    this.update([h, s, v, alpha]);
  }

  handleHueChange = (hue) => {
    const [, s, v, a] = this.state.color;
    this.update([hue, s, v, a]);
  }

  handleSaturationValueChange = (saturation, value) => {
    const [h, , , a] = this.state.color;
    this.update([h, saturation, value, a]);
  }

  update = (color) => {
    this.setState({ color: color });
    this.props.onChange(toHexString(color));
  }

  render() {
    const [hue, saturation, value] = this.state.color;

    return (
      <Wrapper>
        <ColorMap
          x={saturation}
          y={value}
          max={100}
          backgroundColor={this.getBackgroundHue()}
          onChange={this.handleSaturationValueChange}
        />
        <Slider
          vertical
          value={hue}
          max={360}
          onChange={this.handleHueChange}
        />
      </Wrapper>
    );
  }
}

export default ColorPicker;
